import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import { BiMinusCircle } from "react-icons/bi";
import { useMutation, useQuery } from "@apollo/client";

//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

//src
import "../../Style/dialogstyle.scss";
import ListPurchase from "./ListPurchase";
import { AuthContext } from "../../Context/AuthContext";
import { RECIEVE_PURCHASE } from "../../Schema/Reqpurchase";
// import { GET_PURCHASE_BY_REQ_ID } from "../../../Schema/Reqpurchase"
import { SelectWarehouse } from "../Include/DynamicSelect";

export default function ReceivePurchase({
  open,
  handleClose,
  setRefetch,
  editData,
  checkReqPurchaseData,
  setGetPurchaseByCheckReqId,
  getPurchaseByCheckReqId,
}) {
  console.log("ditDatafirst", editData);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectWarehouse, setSelectWarehouse] = useState({ id: "", title: "" });

  const [requireField, setRequireField] = useState(false);
  const calculateSubTotal = () => {
    let subTotal = 0;
    listData.forEach((item) => {
      subTotal +=
        (parseFloat(item.unitPrice) || 0) * (parseFloat(item.qty) || 0);
    });
    return subTotal.toFixed(2);
  };
  const listReqPurchMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "" },
    unitPrice: 0,
    checkUnitPrice: 0,
    qty: 0,
    checkQty: 0,
    image: "",
    key: Date.now() + Math.random(),
    // unitPricePerItem: 0
  };
  const [listData, setListData] = useState([listReqPurchMaterial]);

  //getCheckReqByID

  //receivePurchase
  const [receivePurchase] = useMutation(RECIEVE_PURCHASE, {
    onCompleted: ({ receivePurchase }) => {
      setLoading(false);
      if (receivePurchase?.status) {
        setAlert(true, "success", receivePurchase?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", receivePurchase?.message);
      }
    },
    onError: (error) => {},
  });

  //formik
  const CheckValidation = Yup.object().shape({
    // status: Yup.string().required("required!"),
    dateTime: Yup.date().required("ទាមទារ!"),
    finalShippingFee: Yup.number().min(0),
    warehouseId: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      warehouseId: "",
      finalShippingFee: 0,
      remark: "",
      dateTime: new Date(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {

      // Check Require 
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== "" &&
              elem?.unitPrice > 0 &&
              elem?.qty > 0
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      // 
      if (createStatus) {
        let listReqPurchMaterialToSubmit = listData.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            unitPrice: d?.unitPrice,
            desc: d?.desc,
            qty: d?.qty,
            key: d?.key,
          };
        });

        setLoading(true);
        receivePurchase({
          variables: {
            id: editData?._id,
            ...values,
            receiveMaterials: listReqPurchMaterialToSubmit,
            warehouseId: values?.warehouseId,
            dateTime: values?.dateTime,
          },
        });
      }
    },
  });
  
  useEffect(() => {
    if (editData?.purchaseMaterials?.length !== 0) {
      const dataFromBackend = editData?.purchaseMaterials?.map((d) => {
        // console.log("ddddd",d?.listMaterialUnitId?.imageSrc);
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
          unitPrice: d?.unitPrice,
        };
      });

      setListData([...dataFromBackend]);
    }
  }, [open, editData]);
  useEffect(() => {
    if (editData) {
      console.log("editDatassssss", editData);
      setFieldValue("finalShippingFee", editData?.shippingFee);
    }
  }, [editData, open]);
  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
  } = formik;

  const total =
    parseFloat(calculateSubTotal()) + parseFloat(values?.finalShippingFee);

  useEffect(() => {
    setFieldValue(
      "warehouseId",
      selectWarehouse?.id ? selectWarehouse?.id : ""
    );
  }, [selectWarehouse?.id]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ទទួលទំនិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className="dialog-title-view">សម្ភារៈ</Typography>
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ឃ្លាំងទំនិញ</Typography>
                <SelectWarehouse
                  selectedVal={selectWarehouse}
                  setSelectedVal={setSelectWarehouse}
                />
                {!!errors.warehouseId && touched.warehouseId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.warehouseId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className='field-title'>កាលបរិច្ឆេទទួល</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd-MM-yyyy"  
                    value={values.dateTime ? new Date(values.dateTime) : null}
                    onChange={(newValue) => {
                      setFieldValue( "dateTime" , newValue);
                    }}
                    className="search-field"
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
                
                {!!errors.dateTime && touched.dateTime && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.dateTime}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12}>
                <ListPurchase
                  readOnly
                  listData={listData}
                  setListData={setListData}
                  requireField={requireField}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={1}>
                  <Stack direction="row" width="100%">
                    <Stack width={"32%"}>
                      <Typography className="total-title">តម្លៃ</Typography>
                    </Stack>
                    <Stack width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {calculateSubTotal()}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">
                        ថ្លៃដឹកជញ្ជូន
                      </Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography>:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <TextField
                        inputProps={{ min: 0 }}
                        className="text-field-right"
                        fullWidth
                        type="number"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input":
                            { textAlign: "right" },
                        }}
                        {...getFieldProps("finalShippingFee")}
                        error={Boolean(
                          touched.finalShippingFee && errors.finalShippingFee
                        )}
                        helperText={
                          touched.finalShippingFee && errors.finalShippingFee
                        }
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">តម្លៃសរុប</Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={`space-between`}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {total ? total.toFixed(2) : "0.00"}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            {/* Remarks */}
            <Grid item xs={12}>
              <Typography className="field-title">មតិយោបល់</Typography>
              <TextField
                className="text-field"
                fullWidth
                multiline
                size="small"
                placeholder="remark"
                {...getFieldProps("remark")}
              />
            </Grid>
            <Grid item xs={12}>
              {loading ? (
                <Button className="btn-create" fullWidth>
                  កំពុងដំណើរការ...
                </Button>
              ) : (
                <Button className="btn-create" fullWidth onClick={handleSubmit}>
                  ទទួលទំនិញ
                </Button>
              )}
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
